import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ser-con-barcode-select',
  templateUrl: './con-barcode-select.component.html',
  styleUrl: './con-barcode-select.component.scss'
})
export class ConBarcodeSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'assistenze.fields.conBarcode';

  items: IS1InputSelectItem[] = [];

  constructor(private translateService: TranslateService) {

    this.loadItems();

    this.translateService.onLangChange.subscribe(changed => {
      this.loadItems();
    })

  }

  private loadItems() {
    this.items = [
      { code: null, label: this.translateService.instant("assistenze.fields.conBarcodeAll") },
      { code: true, label: this.translateService.instant("assistenze.fields.conBarcodeYes") },
      { code: false, label: this.translateService.instant("assistenze.fields.conBarcodeNo") },
    ];
  }

  ngOnInit(): void { }

}
